import axios from 'axios';
import { getInvitesAction } from './GetInvitesSlice';

const getInvites = (token) => {
  return async (dispatch) => {
    const fetchData = async () => {
      const url = `${process.env.REACT_APP_DEV_URI}/user/family/invites`;
      const headers = { Authorization: `Bearer ${token}` };
      const response = await axios.get(url, { headers });
      return response;
    };
    try {
      const result = await fetchData();
      dispatch(getInvitesAction.getInvitesSuccess(result.data));
    } catch (e) {
      dispatch(getInvitesAction.getInvitesFailure(e.response?.data ?? e.message));
    }
  };
};

export default getInvites;